import React from 'react';

import { CognitoGetUserMfaStatusDocument, useCognitoGetUserMfaStatusQuery } from 'src/api';

type UserMfaStatusHookParams = {
  userId?: string;
};

export const useUserMfaStatus = (params: UserMfaStatusHookParams) => {
  const { data, loading, variables } = useCognitoGetUserMfaStatusQuery({
    variables: {
      userId: params.userId || '',
    },
    skip: !params.userId,
  });

  const isMfaEnabled = React.useMemo(() => {
    return data?.cognitoGetUserMfaStatus.mfaEnabled || false;
  }, [data?.cognitoGetUserMfaStatus.mfaEnabled]);

  return {
    isMfaEnabled,
    loading,
    queryDocument: CognitoGetUserMfaStatusDocument,
    queryVariables: variables,
  };
};
